import { Button, Grid, Divider } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2.5),
    borderRadius: 10,
    backgroundColor: '#FFF',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  infoCandidat: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: 16,
  },
  avatar: {
    width: '20%',
    height: 'unset',
    aspectRatio: '1',
    borderRadius: '50%',
    marginRight: theme.spacing(1.5),
  },
  divStudent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
  },
  address: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    width: '50%',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  duoTextIcon: {
    display: 'flex',
    alignItems: 'center',
  },
  skeletonColor: {
    backgroundColor: '#D6E7FF !important',
    '&::after': {
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
    },
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
    display: 'inline-block',
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
}));

const CandidatsCardDetailSkeleton = () => {
  const classes = useStyles();
  return (
    <Grid item xs={12} md={3} style={{ padding: '20px 20px 0 0' }}>
      <div className={classes.card}>
        {/* Header avec avatar + nom + actions */}
        <div className={classes.infoCandidat}>
          <Skeleton variant="circle" className={classes.avatar + ' ' + classes.skeletonColor} />
          <div style={{ marginLeft: 12, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
            <div className={classes.divStudent}>
              <Skeleton variant="text" width="60%" height={24} className={classes.skeletonColor} />
              {/* <Skeleton variant="rect" width={32} height={32} className={classes.skeletonColor} style={{ borderRadius: 8 }} /> */}
            </div>
            <div className={classes.address} style={{ marginTop: 0 }}>
              <Skeleton variant="circle" width={20} height={20} className={classes.skeletonColor} />
              <Skeleton variant="text" width="40%" height={18} className={classes.skeletonColor} style={{ marginLeft: 8 }} />
            </div>
          </div>
        </div>

        <Divider className={classes.divider} />

        {/* Infos training, classe, mail, téléphone, entreprise, absence, cycle */}
        {[1, 2, 3, 4, 5, 6, 7].map((i) => (
          <div key={i} className={classes.address + ' ' + classes.duoTextIcon}>
            <Skeleton variant="rect" width={20} height={20} className={classes.skeletonColor + ' ' + classes.icon} />
            <Skeleton variant="text" width="60%" height={18} className={classes.skeletonColor} />
          </div>
        ))}

        <Divider className={classes.divider} />

        {/* Bouton "Voir les détails" */}
        <Skeleton variant="rect" width="100%" height={36} className={classes.skeletonColor} style={{ borderRadius: 4, marginTop: 20 }} />
      </div>
    </Grid>
  );
};

export default CandidatsCardDetailSkeleton; 